<div #videoModal class="m-portlet mf-video-container">
    <div class="m-portlet__head">
        <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
                <h3 class="m-portlet__head-text">
                    <i class="la la-video-camera"></i>
                    ePosvet
                </h3>
            </div>
        </div>
        <div class="m-portlet__head-tools">
            <ul class="m-portlet__nav">
                @if (windowSize === 'small') {
                    <li class="m-portlet__nav-item">
                        <button
                            (click)="moveSmallVideo()"
                            class="m-portlet__nav-link btn btn-secondary m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
                        >
                            <i
                                class="la"
                                [ngClass]="{
                                    'la-caret-square-o-left': modalPosition === 'bottom-right',
                                    'la-caret-square-o-up': modalPosition === 'bottom-left',
                                    'la-caret-square-o-right': modalPosition === 'top-left',
                                    'la-caret-square-o-down': modalPosition === 'top-right',
                                }"
                            ></i>
                        </button>
                    </li>
                }
                <li class="m-portlet__nav-item">
                    <button
                        [disabled]="callState !== callStates.CALL_STARTED"
                        (click)="toggleFullScreen()"
                        class="m-portlet__nav-link btn btn-secondary m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
                    >
                        @if (windowSize !== 'full') {
                            <i class="la la-expand"></i>
                        }
                        @if (windowSize === 'full') {
                            <i class="la la-compress"></i>
                        }
                    </button>
                </li>
                <li class="m-portlet__nav-item">
                    <button
                        [disabled]="callState !== callStates.CALL_STARTED"
                        (click)="toggleModalSize()"
                        class="m-portlet__nav-link btn btn-secondary m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
                    >
                        @if (windowSize !== 'small') {
                            <i class="la la-angle-down"></i>
                        }
                        @if (windowSize === 'small') {
                            <i class="la la-angle-up"></i>
                        }
                    </button>
                </li>
            </ul>
        </div>
    </div>
    <div class="m-portlet__body p-0">
        <div class="video-container">
            @if (callState === callStates.CALL_STARTED) {
                <div class="call-duration">
                    {{ callDuration.formatted }}
                </div>
            }
            @if (callState === callStates.CALL_STARTED) {
                <div class="remote-info">
                    @if (patientReady?.userData?.cameraError) {
                        <div class="text-danger">
                            <i class="la la-video-camera"></i>
                            Pacient nima kamere ali je onemogočil dostop
                        </div>
                    }
                    @if (patientReady?.userData?.microphoneError) {
                        <div class="text-danger">
                            <i class="la la-microphone"></i>
                            Pacient nima mikrofona ali je onemogočil dostop
                        </div>
                    }
                    @if (patientReady?.userData?.cameraMuted && !patientReady?.userData?.cameraError) {
                        <div class="text-warning">
                            <i class="la la-video-camera"></i>
                            Pacient je izključil kamero
                        </div>
                    }
                    @if (patientReady?.userData?.microphoneMuted && !patientReady?.userData?.microphoneError) {
                        <div class="text-warning">
                            <i class="la la-microphone"></i>
                            Pacient je izključil mikrofon
                        </div>
                    }
                    @if (patientReady?.userData?.playoutMuted) {
                        <div class="text-warning">
                            <i class="la la-volume-off"></i>
                            Pacient je izključil zvočnike/slušalke
                        </div>
                    }
                </div>
            }
            <div #remoteVideo id="agora-remote-video" [ngClass]="{ loaded: false }">
                @if (callState === callStates.CALL_STARTED) {
                    @if (!patientReady?.status) {
                        <div class="alert alert-danger">Stranka je zaključila klic ali izgubila povezavo</div>
                    }
                }
            </div>
            <div
                class="local-video-container"
                [ngClass]="{
                    'call-started': callState === callStates.CALL_STARTED && !showSettings,
                    'call-ended': callState === callStates.CALL_ENDING,
                }"
            >
                @if (callState < callStates.CALL_STARTED && callState !== callStates.DEVICE_TEST) {
                    @if (!patientReady?.status && !outsideCallInProgress) {
                        <div class="alert alert-warning">Stranka še ni pripravljena na klic</div>
                    }
                    @if (patientReady?.status && !outsideCallInProgress) {
                        <div class="alert alert-success">Stranka je pripravljena na klic</div>
                    }
                    @if (outsideCallInProgress) {
                        <div class="alert alert-danger">Klic že poteka z uporabnikom {{ outsideCallInProgress?.displayName }}</div>
                    }
                }

                @if (callState === callStates.DEVICE_TEST) {
                    <div class="alert alert-info">Preverjanje delovanja kamere in mikrofona</div>
                }

                @if (callState === callStates.CALL_ENDING) {
                    <div class="text-center">
                        <h5 class="font-weight-bold mb-4">Zapustili ste video</h5>
                        <button (click)="leaveCall()" class="btn m-btn--pill btn-accent my-5">Zapri okno</button>
                        @if (patientReady?.status) {
                            <p>Stranka je še na klicu</p>
                            <p>Klic lahko ponovno vzpostavite</p>
                            <i class="la la-arrow-down"></i>
                        }
                    </div>
                }

                <div id="agora-local-video" [ngClass]="{ loaded: localAvalaible === 'READY' }">
                    @switch (localAvalaible) {
                        @case ('READY') {}
                        @case ('WAITING') {
                            <div class="alert alert-info">Čakam na dostop do kamere...</div>
                        }
                        @case ('NotAllowedError') {
                            <div class="alert alert-danger">
                                Dostop do kamere ali mikrofona je zavrnjen! Preverite nastavitve vašega brskalnika ter operacijskega sistema.
                            </div>
                        }
                        @case ('PERMISSION_DENIED') {
                            <div class="alert alert-danger">
                                Dostop do kamere ali mikrofona je zavrnjen! Preverite nastavitve vašega brskalnika ter operacijskega sistema.
                            </div>
                        }
                        @case ('DEVICES_NOT_FOUND') {
                            <div class="alert alert-danger">
                                Ni ustrezne kamere ali mikrofona! Preverite ali sta kamera in mikrofon priključena in omogočena.
                            </div>
                        }
                        @case ('NotFoundError') {
                            <div class="alert alert-danger">
                                Ni ustrezne kamere ali mikrofona! Preverite ali sta kamera in mikrofon priključena in omogočena.
                            </div>
                        }
                        @case ('MEDIA_OPTION_INVALID') {
                            <div class="alert alert-danger">Kamera je že v uporabi ali ni ustrezne kakovosti.</div>
                        }
                        @case ('NOT_SUPPORTED') {
                            <div class="alert alert-danger">Vaš brskalnik ne podpira uporabe kamere.</div>
                        }
                        @default {
                            <div class="alert alert-danger">Pri dostopu do kamere ali mikrofona je prišlo do napake!</div>
                        }
                    }
                </div>
                @if (callState < callStates.CALL_STARTED || showSettings) {
                    <div class="device-settings">
                        <div class="video-settings">
                            <div><i class="la la-video-camera"></i></div>
                            <div>
                                <span class="m-switch m-switch--outline m-switch--success m-switch--icon">
                                    <label>
                                        <input
                                            [checked]="localVideoEnabled"
                                            [disabled]="localAvalaible !== 'READY'"
                                            (change)="toggleVideo()"
                                            type="checkbox"
                                        />
                                        <span></span>
                                    </label>
                                </span>
                            </div>
                            <div class="device-state">
                                @if (!localVideoEnabled) {
                                    <span class="text-danger">Neaktivno</span>
                                }
                                @if (localVideoEnabled) {
                                    <span class="text-success">Aktivno</span>
                                }
                            </div>
                            <div>
                                <div
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                    class="btn m-btn m-btn--icon popup-to-show btn-secondary dropdown-button"
                                    [ngClass]="{ disabled: localAvalaible !== 'READY' }"
                                >
                                    @if (activeVideoDevice) {
                                        <span>{{ activeVideoDevice }}</span>
                                    }
                                    @if (!activeVideoDevice) {
                                        <span>{{ videoDevices[0]?.label ?? 'Kamera' }}&nbsp;</span>
                                    }
                                    <i class="la la-angle-down"></i>
                                </div>
                                <div class="dropdown-menu">
                                    @for (camera of videoDevices; track camera) {
                                        <a (click)="switchCamera(camera)" class="dropdown-item">
                                            {{ camera.label }}
                                        </a>
                                    }
                                </div>
                            </div>
                        </div>
                        <div class="audio-settings">
                            <div><i class="la la-microphone"></i></div>
                            <div>
                                <span class="m-switch m-switch--outline m-switch--success m-switch--icon">
                                    <label>
                                        <input
                                            [checked]="localAudioEnabled"
                                            [disabled]="localAvalaible !== 'READY'"
                                            (change)="toggleAudio()"
                                            type="checkbox"
                                        />
                                        <span></span>
                                    </label>
                                </span>
                            </div>
                            <div class="device-state">
                                @if (!localAudioEnabled) {
                                    <span class="text-danger">Neaktivno</span>
                                }
                                @if (localAudioEnabled) {
                                    <span class="text-success">Aktivno</span>
                                }
                            </div>
                            <div>
                                <div
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                    class="btn m-btn m-btn--icon popup-to-show btn-secondary dropdown-button"
                                    [ngClass]="{ disabled: localAvalaible !== 'READY' }"
                                >
                                    @if (activeAudioDevice) {
                                        <span>{{ activeAudioDevice }}</span>
                                    }
                                    @if (!activeAudioDevice) {
                                        <span>{{ audioDevices[0]?.label ?? 'Mikrofon' }}&nbsp;</span>
                                    }
                                    <i class="la la-angle-down"></i>
                                </div>
                                <div class="dropdown-menu">
                                    @for (audio of audioDevices; track audio) {
                                        <a (click)="switchAudio(audio)" class="dropdown-item">
                                            {{ audio.label }}
                                        </a>
                                    }
                                </div>
                            </div>
                        </div>
                        <div class="playout-settings">
                            <div>
                                <i class="la la-volume-up"></i>
                            </div>
                            <div>
                                <span class="m-switch m-switch--outline m-switch--success m-switch--icon">
                                    <label>
                                        <input
                                            [checked]="audioVolume > 0 && playoutDevices.length > 0"
                                            [disabled]="localAvalaible !== 'READY'"
                                            (change)="toggleAudioVolume()"
                                            type="checkbox"
                                        />
                                        <span></span>
                                    </label>
                                </span>
                            </div>
                            <div class="device-state">
                                @if (audioVolume === 0) {
                                    <span class="text-danger">Neaktivno</span>
                                }
                                @if (audioVolume > 0) {
                                    <span class="text-success">Aktivno</span>
                                }
                            </div>
                            <div>
                                <div
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                    class="btn m-btn m-btn--icon popup-to-show btn-secondary dropdown-button"
                                    [ngClass]="{ disabled: localAvalaible !== 'READY' }"
                                >
                                    @if (activePlayoutDevice) {
                                        <span>{{ activePlayoutDevice.label }}</span>
                                    }
                                    @if (!activePlayoutDevice) {
                                        <span>Zvočniki</span>
                                    }
                                    <i class="la la-angle-down"></i>
                                </div>
                                <div class="dropdown-menu">
                                    @for (playout of playoutDevices; track playout) {
                                        <a (click)="switchPlayoutDevice(playout)" class="dropdown-item">
                                            {{ playout.label }}
                                        </a>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                }
                @if (callState === callStates.CALL_STARTED && showSettings) {
                    <div class="mt-3 text-center">
                        <button (click)="toggleSettings(false)" class="btn m-btn--pill btn-accent">
                            <i class="la la-close"></i>
                            Zapri nastavitve
                        </button>
                    </div>
                }
            </div>
        </div>
    </div>
    <div class="m-portlet__foot">
        <div class="action-buttons">
            @if (callState < callStates.CALL_STARTED) {
                @if (callState !== callStates.DEVICE_TEST) {
                    <button [disabled]="!patientReady?.status || localAvalaible !== 'READY'" (click)="startCall()" class="btn m-btn--pill btn-accent">
                        <i class="la la-phone"></i>
                        Začni klic
                    </button>
                }
                <button (click)="closeCallWindow()" class="btn m-btn--pill btn-danger">
                    <i class="la la-close"></i>
                    Zapri
                </button>
            }
            @if (callState === callStates.CALL_STARTED || (callState === callStates.CALL_ENDING && patientReady?.status)) {
                <button
                    [disabled]="callState === callStates.CALL_ENDING"
                    (click)="toggleAudio()"
                    class="btn m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill"
                    [ngClass]="{ 'btn-metal': localAudioEnabled, 'btn-danger btn-icon-disabled': !localAudioEnabled }"
                >
                    <i class="la la-microphone"></i>
                </button>
                <button
                    [disabled]="callState === callStates.CALL_ENDING"
                    (click)="toggleVideo()"
                    class="btn m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill"
                    [ngClass]="{ 'btn-metal': localVideoEnabled, 'btn-danger btn-icon-disabled': !localVideoEnabled }"
                >
                    <i class="la la-video-camera"></i>
                </button>
                @if (callState === callStates.CALL_STARTED) {
                    <button
                        (click)="endCall()"
                        data-testid="end-call-button"
                        class="btn m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill btn-danger btn-lg"
                    >
                        <i class="la la-phone"></i>
                    </button>
                }
                @if (callState === callStates.CALL_ENDING) {
                    <button (click)="restartCall()" class="btn m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill btn-success btn-lg">
                        <i class="la la-phone"></i>
                    </button>
                }
                <button
                    [disabled]="callState === callStates.CALL_ENDING"
                    (click)="setAudioVolume()"
                    class="btn m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill"
                    [ngClass]="{ 'btn-metal': audioVolume > 0, 'btn-danger btn-icon-disabled': audioVolume === 0 }"
                >
                    @if (audioVolume >= 75) {
                        <i class="la la-volume-up"></i>
                    }
                    @if (audioVolume > 0 && audioVolume < 75) {
                        <i class="la la-volume-down"></i>
                    }
                    @if (audioVolume === 0) {
                        <i class="la la-volume-off"></i>
                    }
                </button>
                <button
                    [disabled]="callState === callStates.CALL_ENDING"
                    (click)="toggleSettings()"
                    class="btn m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill"
                    [ngClass]="{ 'btn-metal': !showSettings, 'btn-info': showSettings }"
                >
                    <i class="la la-gear"></i>
                </button>
            }
        </div>
    </div>
</div>
